import { axiosWrapper } from "../../axiosWrapper";
import { ICustomerPayload } from "../../pages/CustomerAccount/CustomerList";

export class CustomerService {
  // get All Customer Details
  public static async getAllCustomerAccountsInfo(
    customerPayload: ICustomerPayload
  ) {
    return await axiosWrapper.Post(
      `CustomerAccount/GetCustomerAccountsInfo`,
      customerPayload
    );
  }

  public static async getCustomerAccountsInfoById(id: string) {
    return await axiosWrapper.Get(`CustomerAccount/CustomerAccountInfo/${id}`);
  }

  public static async getCustomerAccountsById(id: string) {
    return await axiosWrapper.Get(`CustomerAccount/${id}`);
  }

  public static async addCustomerAccount(CustomerInfoRecord: {}) {
    try {
      console.log('🚀 Sending Customer Account Creation:');
      console.log('🎯 Backend Endpoint: CustomerAccount/AddCustomerAccountsInfo');

      const response = await axiosWrapper.Post(
        "CustomerAccount/AddCustomerAccountsInfo",
        CustomerInfoRecord
      );
      
      console.log('✅ Backend Response Received for Customer Creation');
      return response;
    } catch (error) {
      console.error('❌ Error in Customer Account Creation:', error);
      throw error;
    }
  }

  public static async deleteCustomerAccount(id: string, partitionKey: string) {
    return await axiosWrapper.Delete(
      `CustomerAccount/DeleteCustomerInfo/${id}/${partitionKey}`
    );
  }

  public static async updateCustomerAccount(CustomerInfoRecord: {}) {
    return await axiosWrapper.Patch(
      "CustomerAccount/UpdateCustomerAccountInfo",
      CustomerInfoRecord
    );
  }

  public static async searchCustomer(searchText: string) {
    return await axiosWrapper.Get(
      `CustomerAccount/SearchCustomer/${searchText}`
    );
  }

  public static async getCustomerByAccountId(accountId: string) {
    return await axiosWrapper.Get(
      `CustomerAccount/CustomerByAccountId/${accountId}`
    );
  }

  public static async validateMsxOpportunityId(id: string) {
    return await axiosWrapper.GetValidate(
      `MSX/ValidateMSXOppertunityId/${id}`,
      true
    );
  }

  public static async validateCustomerTaxId(id: string) {
    return await axiosWrapper.Get(
      `CustomerAccount/SearchCustomerByTaxId/${id}`
    );
  }

  public static async getCustomerContactById(id: string) {
    return await axiosWrapper.Get(`CustomerContacts/Customer/${id}`);
  }

  public static async addCustomerContact(CustomerContact: {}) {
    return await axiosWrapper.Post(`CustomerContacts`, CustomerContact);
  }

  public static async updateCustomerContact(CustomerContact: {}) {
    return await axiosWrapper.Put(`CustomerContacts`, CustomerContact);
  }

  public static async updateCustomerAddress(CustomerInfoRecord: {}) {
    return await axiosWrapper.Patch(
      "CustomerAccount/UpdateCustomerAddressInfo",
      CustomerInfoRecord
    );
  }
  
  public static async getMSEFriendlyCustomerAccountNumber() {
    return await axiosWrapper.Get(`CustomerAccount/MSEFriendlyCustomerAccountNumber`);
  }
}
